module.exports = __webpack_public_path__ + "static/media/grid-chart-solid.543c2ded.svg";